// Socket topics that represent a deal-version change ("Get The Latest"). The socket is subscribed
// to additional topics (e.g. pushToFI, mv_docMove) that must NOT trigger a deal-refresh.
export const DealXgTopic = {
    DEAL_XG_CREATE: 'dealXgCreate',
    DEAL_XG_PATCH: 'dealXgPatch'
};
